import { useMemo } from 'react';
import { resolveBidStatusOptions } from '../capabilities';

const useBidStatusOptions = (bid) =>
	useMemo(() => resolveBidStatusOptions(bid, { hasDeposits: true }), [bid]);

export default useBidStatusOptions;
